import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

export interface AppConfig {
    idampUserDefaultDomain: string;
    idampApiBaseUrl: string;
    primaryUserApiBaseUrl: string;
    idampOtherApiBaseUrl: string;
    alertInfoMessage: string;
    tokenScopes: string[];
    cmdbServiceIdUrlReplaceToken: string;
    cmdbServiceIdUrl: string;
}

@Injectable({ providedIn: 'root' })
export class AppConfigService {
    private config: AppConfig;
    loaded: boolean = true; // Always true now since we use compile-time config

    constructor() { 
        // Load config from environment instead of runtime HTTP call
        this.config = {
            idampUserDefaultDomain: environment.idampUserDefaultDomain,
            idampApiBaseUrl: environment.idampApiBaseUrl,
            primaryUserApiBaseUrl: environment.primaryUserApiBaseUrl,
            idampOtherApiBaseUrl: environment.idampOtherApiBaseUrl,
            alertInfoMessage: environment.alertInfoMessage,
            tokenScopes: environment.tokenScopes,
            cmdbServiceIdUrlReplaceToken: environment.cmdbServiceIdUrlReplaceToken,
            cmdbServiceIdUrl: environment.cmdbServiceIdUrl,
        };
    }

    async loadConfig(): Promise<void> {
        // No-op now, config is loaded in constructor
        // Keeping this method for backward compatibility
        return Promise.resolve();
    }

    getConfig(): AppConfig { return this.config; }
}